import { render, staticRenderFns } from "./o-button-language.vue?vue&type=template&id=1fc6aeb1"
import script from "./o-button-language.js?vue&type=script&lang=js&external"
export * from "./o-button-language.js?vue&type=script&lang=js&external"
import style0 from "./o-button-language.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports